<template>
    <div id="foot">
        <div class="foot_list">
            <div class="width1220 clearfix">
                <div class="foot_intro">
                    <ul>
                        <li><i class="foot_icon1"></i>课程齐全/学习轻松</li>
                        <li><i class="foot_icon2"></i>支付安全/方便快捷</li>
                        <li><i class="foot_icon3"></i>安全文化/安泰做起</li>
                        <li><i class="foot_icon4"></i>每月有课/取证便捷</li>
                    </ul>
                </div>
                <div class="foot_nav">
                    <div class="foot_nav_list">
                        <p>如何购买学习</p>
                        <ul>
                            <li><a href="#" target="_blank">如何注册与登录</a></li>
                            <li><a href="#" target="_blank">如何购买课程</a></li>
                            <li><a href="#" target="_blank">如何填写学表</a></li>
                        </ul>
                    </div>
                    <div class="foot_nav_list">
                        <p>支付方式</p>
                        <ul>
                            <li><a href="#" target="_blank">在线支付</a></li>
                            <li><a href="#" target="_blank">银行转账</a></li>

                        </ul>
                    </div>
                    <div class="foot_nav_list">
                        <p>课程</p>
                        <ul>
                            <li><a href="#" target="_blank">如何查询</a></li>

                        </ul>
                    </div>
                    <div class="foot_nav_list">
                        <p>售后服务</p>
                        <ul>
                            <li><a href="#" target="_blank">如何找回密码</a></li>
                            <li><a href="#" target="_blank">开发票流程</a></li>
                            <li><a target="_blank">投诉</a></li>
                        </ul>
                    </div>
                    <div class="foot_nav_list">
                        <p>关于安泰教育</p>
                        <ul>
                            <li><a href="#" target="_blank">加入安泰</a></li>
                            <li><a href="#" target="_blank">联系我们</a></li>
                            <li><a href="http://218.91.114.159:9999" target="_blank">培训管理系统</a></li>
                            <!--<li><a href="http://47.104.157.125/NewFolder/login/AnTaiLogin.html"-->
                                   <!--target="_blank">旧培训管理系统</a></li>-->
                        </ul>
                    </div>
                </div>
                <div class="foot_phone">
                    <h3>0533-2150155</h3>
                    <p>周一至周日 8:00-18:00<br>（********）</p>
                    <a href="##" target="_blank">12 小时在线客服</a>
                </div>
            </div>
        </div>
        <div class="foot_info">
            <div class="width1220 clearfix">
                <div class="foot_con">
                    <p>Copyright © 1999-2018 All Rights Reserved 版权所有：淄博安泰文化传播有限公司 备案号：<a href="http://www.beian.miit.gov.cn" target="_blank">鲁ICP备17016860号</a></p>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import './../assets/css/foot.css'

    export default {

        name: "Foot",
        methods: {

        },
    }
</script>
